// Questionnaire/MentalHealthPicker.tsx
import React, {useEffect, useState} from 'react';
import {Controller} from 'react-hook-form';
import RadioLine from 'Core/components/elements/RadioLine';
import {axios} from 'Auth/axiosConfig';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import Typography from '@mui/material/Typography';
import CircularProgress from 'Core/components/elements/CircularProgress';

interface MentalHealthOption {
    value: string | number;
    display: string | number;
}

interface MentalHealthPickerProps {
    control: any;
    name: string; // For example, 'mental_health'
    required?: boolean;
}

const AgePicker: React.FC<MentalHealthPickerProps> = (
    {
        control,
        name,
        required = true,
    }) => {
    const [options, setOptions] = useState<MentalHealthOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        const fetchMentalHealthOptions = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/api/v1/client/age/');
                setOptions(response.data);
                setLoading(false);
            } catch (err) {
                setError('Не удалось загрузить варианты состояния психического здоровья');
                byResponse(err);
                setLoading(false);
            }
        };

        fetchMentalHealthOptions();
    }, [byResponse]);

    if (loading) {
        return <CircularProgress size={'50px'}/>;
    }

    if (error) {
        return <Typography color="error">{error}</Typography>;
    }

    return (
        <Controller
            name={name}
            control={control}
            rules={{required: required ? 'Это поле обязательно' : false}}
            render={({field, fieldState: {error}}) => (
                <>
                    <RadioLine
                        options={options.map((option) => ({
                            value: option.value,
                            label: option.display,
                        }))}
                        selectedValue={field.value}
                        onChange={(value) => field.onChange(value)}
                        className="w-100 fr gap-2 flex-wrap"
                        itemClass={'rounded-3'}
                        minWidth={130}

                    />
                    {error && (
                        <Typography color="error" variant="body2">
                            {error.message}
                        </Typography>
                    )}
                </>
            )}
        />
    );
};

export default AgePicker;
